"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const drag_drop_1 = require("@angular/cdk/drag-drop");
const core_1 = require("@angular/core");
const _ = require("lodash");
class EditWorkflowComponent {
    constructor() {
        this.item = null;
        this.context = null;
        this.steps = null;
        this.workflowsToken = 'WORKFLOWS.CUSTOM';
        this.workflowToken = null;
        this.states = [
            { label: 'Open', id: 'open', uid: null, display: true, items: [] },
            { label: 'In queue', id: 'in_queue', uid: null, display: true, items: [] },
            { label: 'In processing', id: 'in_processing', uid: null, display: true, items: [] },
            { label: 'Success', id: 'finished_success', uid: null, display: true, items: [] },
            { label: 'Failed', id: 'finished_failed', uid: null, display: true, items: [] },
            { label: 'Aborted', id: 'finished_aborted', uid: null, display: true, items: [] }
        ];
        this.itemTypes = [
            { label: 'Text', id: 'text', uid: null, type: 'plain', icon: 'font', display: true, label_token: '', text_token: '', value: '', conditions: [] },
            { label: 'Input', id: 'input', uid: null, type: 'text', icon: 'i-cursor', display: true, label_token: '', text_token: '', value: '', required: false, action: null, action_param: null, min: 1, max: 10, step: 1, options: [], conditions: [] },
            { label: 'Control', id: 'control', uid: null, type: 'button', icon: 'cog', display: true, label_token: '', text_token: '', value: '', required: false, action: null, action_param: null, min: 1, max: 10, step: 1, options: [], conditions: [] },
            { label: 'Action', id: 'action', uid: null, type: 'goto', icon: 'play-circle', display: true, target: null, value: '', conditions: [] }
        ];
        this.textTypes = [
            { label: 'Plain', id: 'plain' },
            { label: 'Heading', id: 'heading' },
            { label: 'Alert', id: 'alert' },
            { label: 'Note', id: 'note' }
        ];
        this.inputTypes = [
            { label: 'Checkboxes', id: 'checks' },
            { label: 'Text', id: 'text' },
            { label: 'Number', id: 'number' },
            { label: 'Slider', id: 'slider' },
            { label: 'Color', id: 'color' },
        ];
        this.controlTypes = [
            { label: 'Button', id: 'button' },
            { label: 'Switch', id: 'check' },
            { label: 'List', id: 'select' },
            { label: 'Radio', id: 'radio' },
        ];
        this.actionTypes = [
            { label: 'Go to step', id: 'goto' },
            { label: 'Cancel', id: 'cancel' },
            { label: 'Start processing', id: 'process' },
            { label: 'Stop processing', id: 'abort' },
            { label: 'Show', id: 'show' },
            { label: 'Hide', id: 'hide' }
        ];
        this.checkTypes = [
            { label: 'Like', id: 'like' },
            { label: 'Unlike', id: 'unlike' },
            { label: 'Less than', id: 'less' },
            { label: 'More than', id: 'more' },
        ];
        this.defaultStates = [
            { name: 'open', label: 'Open', default: true },
            { name: 'queued', label: 'In queue' },
            { name: 'processing', label: 'Processing' },
            { name: 'success', label: 'Success' },
            { name: 'failed', label: 'Failed' },
            { name: 'aborted', label: 'Aborted' },
        ];
        this.allItems = {};
    }
    ngOnInit() {
        if (!this.item['worflow-template']) {
            this.item['worflow-template'] = [];
        }
        this.steps = this.item['worflow-template'];
        this.workflowToken = this.workflowsToken + ('.' + this.item.uid).toUpperCase();
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    resetParentCache() {
        if (this.context) {
            this.context.pluginCache = null;
            this.context.saveWorkflow(this.steps);
        }
    }
    addStep() {
        this.steps.push({ id: this.uuidv4(), step: this.steps.length, label_token: this.workflowToken + '.STEP_' + (this.steps.length + 1), states: [], display: true, hideHeader: false });
        this.resetParentCache();
    }
    removeStep(me) {
        this.steps = this.steps.filter(function (returnableObjects) {
            return returnableObjects.id !== me.id;
        });
        this.resetParentCache();
    }
    dropStep(event) {
        console.log('@@@ dropStep()', event);
        let idx = event.currentIndex;
        let item = event.container.data[idx];
        if (item) {
            event.container.data[idx]['step'] = idx;
            event.container.data[idx]['label_token'] = this.workflowToken + '.STEP_' + (idx + 1);
        }
        drag_drop_1.moveItemInArray(this.steps, event.previousIndex, event.currentIndex);
        this.resetParentCache();
    }
    dropState(event) {
        console.log('@@@ dropState()', event);
        // moveItemInArray(this.steps, event.previousIndex, event.currentIndex);
    }
    hasState(step, state) {
        let find = step.states.find(s => s.id == state.id);
        if (find) {
            return true;
        }
        return false;
    }
    setupState(step, incoming_state, event = null) {
        let state = _.cloneDeep(incoming_state);
        let id = state.id;
        let find = step.states.find(s => s.id == id);
        console.log('@@@ setupState()', step, state, event, find);
        if (event.checked) {
            if (!find) {
                state.uid = this.uuidv4();
                step.states.push(state);
            }
        }
        else {
            if (find) {
                // remove
                step.states = step.states.filter(s => s.id !== id);
            }
        }
        this.resetParentCache();
    }
    dropItem(event) {
        if (event.previousContainer === event.container) {
            console.log('@@@ dropItem() MOVE', event, event.container);
            drag_drop_1.moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            console.log('@@@ dropItem() COPY', event, event.container);
            // Clone the item that was dropped.
            const clone = _.cloneDeep(event.previousContainer.data[event.previousIndex]);
            // Add the clone to the new array.
            event.container.data.splice(event.currentIndex, 0, clone);
            let idx = event.currentIndex;
            let item = event.container.data[idx];
            if (item && !item['uid']) {
                event.container.data[idx]['uid'] = this.uuidv4();
                this.allItems[event.container.data[idx]['uid']] = event.container.data[idx];
            }
            console.log('@@@ dropItem() COPY', event, idx, item);
        }
        this.resetParentCache();
    }
    removeItem(item = null, state = null) {
        state.items = state.items.filter(i => i.uid !== item.uid);
        this.resetParentCache();
    }
    getStepLabel(id = '') {
        let find = this.steps.find(s => s.id == id);
        if (find) {
            return 'Step ' + (find.step + 1);
        }
    }
    getItemLabel(id = '') {
        if (this.allItems[id]) {
            return this.allItems[id].id + ':' + this.allItems[id].type + ':' + this.allItems[id].text_token;
        }
        return null;
    }
    addCondition(item = null) {
        item.conditions.push({ uid: this.uuidv4(), thisOne: '', check: '', thatOne: '' });
        this.resetParentCache();
    }
    dropCondition(event) {
        console.log('@@@ dropCondition()', event);
        drag_drop_1.moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        this.resetParentCache();
    }
    removeCondition(item = null, condition = null) {
        // let find = item.conditions.find ( c => c.uid == condition.uid );
        item.conditions = item.conditions.filter(c => c.uid !== condition.uid);
        this.resetParentCache();
    }
    done() {
        if (this.context) {
            this.context.editWorkflowSelected = null;
        }
    }
    show(item) {
        item.display = true;
    }
    hide(item) {
        item.display = false;
    }
}
exports.EditWorkflowComponent = EditWorkflowComponent;
